import React, { useState } from 'react'
import { faAlignCenter, faAlignJustify, faAlignLeft, faAlignRight, faBold, faItalic } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
const OpcionesTitulo = (props) => {
    const { type, id, handleEstilosComponente, styles } = props;
    const [bold, setBold] = useState(styles.bold ? styles.bold : false)
    const [italic, setItalic] = useState(styles.italic ? styles.italic : false)
    const [tag, setTag] = useState(styles?.Tag)
    const [justify, setJustify] = useState(styles?.justify)
    const [color, setColor] = useState(styles?.color)

    return (
        <div className='titulo-button'>
            <div className='mb-2'>
                <button type='button' className={bold && 'boton-activo'} onClick={(e) => { handleEstilosComponente({ type, id, valor: !bold, nombre: 'bold' }); setBold(!bold) }}>
                    <FontAwesomeIcon icon={faBold} />
                </button>
                <button className={italic && 'boton-activo'} onClick={(e) => { handleEstilosComponente({ type, id, valor: !italic, nombre: 'italic' }); setItalic(!italic) }}>
                    <FontAwesomeIcon icon={faItalic} />
                </button>
            </div>

            <div className='mb-2'>
                <button className={tag == 'h1' && 'boton-activo'} onClick={(e) => { handleEstilosComponente({ type, id, valor: 'h1', nombre: 'Tag' }); setTag('h1') }}>
                    H1
                </button>
                <button className={tag == 'h2' && 'boton-activo'} onClick={(e) => { handleEstilosComponente({ type, id, valor: 'h2', nombre: 'Tag' }); setTag('h2') }}>
                    H2
                </button>
                <button className={tag == 'h3' && 'boton-activo'} onClick={(e) => { handleEstilosComponente({ type, id, valor: 'h3', nombre: 'Tag' }); setTag('h3') }}>
                    H3
                </button>
                <button className={tag == 'h6' && 'boton-activo'} onClick={(e) => { handleEstilosComponente({ type, id, valor: 'h6', nombre: 'Tag' }); setTag('h6') }}>
                    h6
                </button>
                <button className={tag == 'h5' && 'boton-activo'} onClick={(e) => { handleEstilosComponente({ type, id, valor: 'h5', nombre: 'Tag' }); setTag('h5') }}>
                    H5
                </button>
                <button className={tag == 'h6' && 'boton-activo'} onClick={(e) => { handleEstilosComponente({ type, id, valor: 'h6', nombre: 'Tag' }); setTag('h6') }}>
                    H6
                </button>
            </div>

            <div className='mb-2'>
                <button className={justify == 'left' && 'boton-activo'} onClick={(e) => { handleEstilosComponente({ type, id, valor: 'left', nombre: 'justify' }); setJustify('left') }} >
                    <FontAwesomeIcon icon={faAlignLeft} />
                </button>
                <button className={justify == 'center' && 'boton-activo'} onClick={(e) => { handleEstilosComponente({ type, id, valor: 'center', nombre: 'justify' }); setJustify('center') }}>
                    <FontAwesomeIcon icon={faAlignCenter} />
                </button>
                <button className={justify == 'right' && 'boton-activo'} onClick={(e) => { handleEstilosComponente({ type, id, valor: 'right', nombre: 'justify' }); setJustify('right') }}>
                    <FontAwesomeIcon icon={faAlignRight} />
                </button>
            </div>

            <div className='mb-2'>
                <h5>Titulo</h5>
                <input
                    defaultValue={styles.textoTitulo}
                    type="text"
                    className="form-control form-control-sm"
                    onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'textoTitulo' })}
                />
            </div>

            <div className='mb-2'>
                <h5>Color</h5>
                <input
                    type="color"
                    id="exampleColorInput"
                    value={color}
                    onChange={(e) => { handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'color' }); setColor(e.target.value) }}
                    title="Choose your color"
                />
            </div>


        </div>
    )
}

export default OpcionesTitulo